<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.cc_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="cc_emname">
            <label class="weui-form-preview__label">{{customLabel.cc_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.cc_emname}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cc_rep_emname">
            <label class="weui-form-preview__label">{{customLabel.cc_rep_emname || "调班对象"}}</label>
            <span class="weui-form-preview__value">{{form.main.cc_rep_emname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cc_time">
            <label class="weui-form-preview__label">{{customLabel.cc_time || "调班日期"}}</label>
            <span class="weui-form-preview__value">{{dateFormat(form.main.cc_time, "yyyy-MM-dd")}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cc_rep_time">
            <label class="weui-form-preview__label">{{customLabel.cc_rep_time || "还班日期"}}</label>
            <span class="weui-form-preview__value">{{dateFormat(form.main.cc_rep_time, "yyyy-MM-dd")}}</span>
          </div>
          <div class="weui-form-preview__item" slot="cc_remark"> 
            <label class="weui-form-preview__label">{{customLabel.cc_remark || "调班事由"}}</label>
            <span class="weui-form-preview__value">{{form.main.cc_remark}}</span>
          </div>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/changeclass_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout
  },
  data() {
    return {
      baseUrl: "/api/hr/changeClass",
      codeField: "cc_code",
      statusField: "cc_statuscode",
      caller: "HrChangeClass",
      xtype: "hr-changeclass-formpanel",
    };
  }
};
</script>